<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>アカウント申請詳細</h1>
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-col cols="4" md="3" class="py-0">
        <mp-button min wide @click="goChange">申請内容変更</mp-button>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" message-key="message.admin.account.error." />
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>ID</mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>{{ view.mailAddress }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>氏名</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.name }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>所属</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.groupLarge.groupLargeName.ja }}<span class="mx-2">＞</span>{{ view.groupSmall.groupSmallName.ja }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ view.groupSmall.companyLabel.ja }}</mp-label>
      </v-col>
      <v-col cols="8">
        <v-icon v-if="view.companyId === 0">mdi-new-box</v-icon>
        <mp-input-box>{{ view.companyName }}</mp-input-box>
        <mp-input-box>{{ view.companyNameKana }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ view.groupSmall.branchLabel.ja }}</mp-label>
      </v-col>
      <v-col cols="8">
        <v-icon v-if="view.branchId === 0">mdi-new-box</v-icon>
        <mp-input-box>{{ view.branchName }}</mp-input-box>
        <mp-input-box>{{ view.branchNameKana }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>郵便番号</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.postNo }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>都道府県</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ $store.getters.prefNameByCode(view.prefCd).ja }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>市区町村</mp-label>
      </v-col>
      <v-col cols="8" dense>
        <mp-input-box>{{ view.addr1 }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>番地</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.addr2 }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>ビル名</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.addr3 }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>部署</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.busho }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>電話番号</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.telNo }}</mp-input-box>
      </v-col>
    </v-row>

    <!-- 備考 -->
    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>備考</mp-label>
      </v-col>
      <v-col cols="8" class="pr-0">
        <mp-multiple-lines-input-box>{{ view.remarks }}</mp-multiple-lines-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>利用希望サービス</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <ul class="serviceList">
            <li v-for="s in view.services" :key="s.serviceId">
              {{ s.serviceNameJp }}
            </li>
          </ul>
        </mp-input-box>
      </v-col>
    </v-row>

    <!-- フリーランス申請詳細 start -->
    <template v-if="view.freelance">
      <v-row justify="center">
        <v-col cols="12">
          <h1 class="mt-5">フリーランス申請</h1>
        </v-col>
      </v-row>

      <!-- 推薦媒社名 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>推薦媒社名</mp-label>
        </v-col>
        <v-col cols="8">
          <mp-input-box>{{ view.freelance.recommendationCompanyName }}</mp-input-box>
        </v-col>
      </v-row>

      <!-- 推薦媒体名 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>推薦媒体名</mp-label>
        </v-col>
        <v-col cols="8">
          <mp-input-box>{{ view.freelance.recommendationMediaName }}</mp-input-box>
        </v-col>
      </v-row>

      <!-- 媒体内容 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>媒体内容</mp-label>
        </v-col>
        <v-col cols="8" class="pr-0">
          <mp-multiple-lines-input-box>{{ view.freelance.mediaContents }}</mp-multiple-lines-input-box>
        </v-col>
      </v-row>

      <!-- 媒体発行詳細 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>媒体発行詳細</mp-label>
        </v-col>
        <v-col cols="8" class="pr-0">
          <mp-multiple-lines-input-box>{{ view.freelance.mediaIssueDetail }}</mp-multiple-lines-input-box>
        </v-col>
      </v-row>

      <!-- 推薦責任者名 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>推薦責任者名</mp-label>
        </v-col>
        <v-col cols="8">
          <mp-input-box>{{ view.freelance.recommendationResponsibleName }}</mp-input-box>
        </v-col>
      </v-row>

      <!-- 推薦責任者メールアドレス -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>推薦責任者メールアドレス</mp-label>
        </v-col>
        <v-col cols="8">
          <mp-input-box>{{ view.freelance.recommendationResponsibleMailAddress }}</mp-input-box>
        </v-col>
      </v-row>

      <!-- 推薦理由 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>推薦理由</mp-label>
        </v-col>
        <v-col cols="8" class="pr-0">
          <mp-multiple-lines-input-box>{{ view.freelance.recommendationReason }}</mp-multiple-lines-input-box>
        </v-col>
      </v-row>

      <!-- 取材活動実績 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>取材活動実績</mp-label>
        </v-col>
        <v-col cols="8" class="pr-0">
          <div>
            <mp-multiple-lines-input-box>{{ view.freelance.trackRecord }}</mp-multiple-lines-input-box>
          </div>
          <div class="my-3">
            <div class="px-2" v-for="file in view.freelance.files" :key="file.url"><a :href="file.url">{{ file.name }}</a></div>
          </div>
        </v-col>
      </v-row>

    </template>
    <!-- フリーランス申請詳細 end -->

    <!-- ローカル媒体申請 start -->
    <template v-if="view.localMedia">
      <v-row justify="center">
        <v-col cols="12">
          <h1 class="mt-5">ローカル媒体申請</h1>
        </v-col>
      </v-row>

      <!-- 媒体発行詳細 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>媒体発行詳細</mp-label>
        </v-col>
        <v-col cols="8">
          <mp-multiple-lines-input-box>{{ view.localMedia.mediaIssueDetail }}</mp-multiple-lines-input-box>
        </v-col>
      </v-row>

      <!-- 媒体カバーエリア -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>媒体カバーエリア</mp-label>
        </v-col>
        <v-col cols="8">
          <mp-multiple-lines-input-box>{{ view.localMedia.mediaCoverageArea }}</mp-multiple-lines-input-box>
        </v-col>
      </v-row>

      <!-- グループ責任者名 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>グループ責任者名</mp-label>
        </v-col>
        <v-col cols="8">
          <mp-input-box>{{ view.localMedia.groupResponsibleName }}</mp-input-box>
        </v-col>
      </v-row>

      <!-- 利用者名 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>利用者名</mp-label>
        </v-col>
        <v-col cols="8">
          <mp-multiple-lines-input-box>{{ view.localMedia.userName }}</mp-multiple-lines-input-box>
        </v-col>
      </v-row>

      <!-- ローカル媒体管理クラブ -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>ローカル媒体管理クラブ</mp-label>
        </v-col>
        <v-col cols="8">
          <p v-for="clubCode in view.localMedia.localMediaManagementClub" :key="clubCode">{{ $store.getters.localMediaManagementClubNameByCode(clubCode).ja }}</p>
        </v-col>
      </v-row>

      <!-- その他 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>その他</mp-label>
        </v-col>
        <v-col cols="8">
          <mp-multiple-lines-input-box>{{ view.localMedia.other }}</mp-multiple-lines-input-box>
        </v-col>
      </v-row>

    </template>
    <!-- ローカル媒体申請 end -->

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="2"
      >
        <mp-button wide @click="goList">戻る</mp-button>
      </v-col>
      <v-col
        class="text-center"
        cols="4"
      >
        <mp-button red wide @click="dialog.rejectMailForm = true">却下</mp-button>
      </v-col>
      <v-col
        class="text-center"
        cols="4"
      >
        <mp-button red wide @click="dialog.approvalConfirm = true">承認</mp-button>
        <mp-dialog approval confirm :show="dialog.approvalConfirm" @clickOk="goApproval"
                   @clickCancel="dialog.approvalConfirm = false"/>
        <mp-dialog approval :show="dialog.approvalComplete" @clickOk="goList"/>
      </v-col>
    </v-row>

    <reject-mail-form :show="dialog.rejectMailForm"
                      :accountEntryId="accountEntryId"
                      :mail="view.rejectMail"
                      @change-show="dialog.rejectMailForm = $event">
    </reject-mail-form>

  </v-container>
</template>

<script>
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import { AdminAccountEntry, Common } from '@/api'
import MpError from '@/components/item/MpError'
import StringUtils from '@/utils/StringUtil'
import MpMultipleLinesInputBox from '@/components/item/MpMultipleLinesInputBox.vue'
import RejectMailForm from './RejectMailForm.vue'

export default {
  name: 'top',
  components: {
    MpError,
    MpLabel,
    MpInputBox,
    MpButton,
    MpDialog,
    MpMultipleLinesInputBox,
    RejectMailForm
  },
  data: () => ({
    accountEntryId: null,
    view: {
      errors: [],
      accountEntryId: '',
      mailAddress: '',
      name: '',
      groupLarge: {
        groupLargeName: {
          ja: '',
          en: ''
        }
      },
      groupSmall: {
        groupSmallName: {
          ja: '',
          en: ''
        },
        companyLabel: {
          ja: ''
        },
        branchLabel: {
          ja: ''
        }
      },
      companyId: '',
      companyName: '',
      companyNameKana: '',
      branchId: '',
      branchName: '',
      branchNameKana: '',
      postNo: '',
      prefCd: '',
      addr1: '',
      addr2: '',
      addr3: '',
      busho: '',
      telNo: '',
      remarks: '',
      services: [],
      rejectMail: {
        subject: '',
        body: ''
      },
      freelance: null,
      localMedia: null
    },
    dialog: {
      approvalConfirm: false,
      approvalComplete: false,
      rejectMailForm: false
    }
  }),
  computed: {},
  methods: {
    goList () {
      // 一覧画面に戻る
      this.$router.push({ path: '/admin/account/entry/list' })
    },
    goChange () {
      // 申請内容変更画面へ
      this.$router.push({ path: '/admin/account/entry/change/' + this.accountEntryId })
    },
    async goApproval () {
      // ダイアログ非表示
      this.dialog.approvalConfirm = false

      await AdminAccountEntry.approve({ accountEntryIdList: [this.accountEntryId] })
        .then(() => { this.dialog.approvalComplete = true })
        .catch(error => { this.view.errors = error.messages })
    },
    async setDefaultLabel () {
      const list = await Common.labelList({ key: 'default' })
      this.view.groupSmall.companyLabel.ja = StringUtils.isEmpty(this.view.groupSmall.companyLabel.ja)
        ? this.getDefaultLabelFromList(list, 'label.default.company.ja')
        : this.view.groupSmall.companyLabel.ja

      this.view.groupSmall.branchLabel.ja = StringUtils.isEmpty(this.view.groupSmall.branchLabel.ja)
        ? this.getDefaultLabelFromList(list, 'label.default.branch.ja')
        : this.view.groupSmall.branchLabel.ja
    },
    getDefaultLabelFromList (list, key) {
      const ele = list.find(ele => ele.configKey === key)
      if (ele === undefined || ele.configVal === undefined) {
        return ''
      }
      return ele.configVal
    }
  },
  created: async function () {
    this.view.errors = []
    // パラメータからアカウント申請IDを取得
    this.accountEntryId = this.$route.params.id

    // アカウント情報取得
    const result = await AdminAccountEntry.detail({ accountEntryId: this.accountEntryId })
      .catch(error => { this.view.errors = error.messages })
    this.view = { ...this.view, ...result }

    await this.setDefaultLabel()
  }
}
</script>

<style scoped>
  .v-icon.mdi-new-box {
    color: #E62233;
  }
</style>
